module.exports = __webpack_public_path__ + "img/rails.3247e1d0.svg";